import {UserPersona} from "@khan/guide-types";
import type {UserAttributes} from "@khan/shared-core";

import {maybeGetAsStudentPersona} from "./maybe-get-as-student-persona.ts";

export const isLearnerPersona = ({
    userAttributes,
    pathname,
    isEmulatingLearner,
}: {
    userAttributes: UserAttributes | null | undefined;
    pathname: string;
    isEmulatingLearner: boolean;
}) => {
    const persona = maybeGetAsStudentPersona(
        userAttributes,
        pathname,
        isEmulatingLearner,
    );
    // The default is a learner persona.
    if (!persona) {
        return true;
    }
    return persona === UserPersona.Student;
};
